import _ from 'underscore';
import Backbone from 'backbone';
import '../backbone-relational-isomorphic';

var Track = Backbone.RelationalModel.extend({
    relations: [
    ],

    defaults: {
        disabled: false
    },

    initialize: function() {
    }

});
export default Track;

